import { Link } from 'react-router-dom';

export const HouseSection = () => {
  return (
    <section className="relative h-54em w-full">
      <div className="px-10 md:px-24 bg-cover bg-center bg-castle bg-no-repeat absolute top-0 right-0 bottom-0 left-0">
        <div className="flex flex-col gap-8 py-10 m-auto max-w-108">
          <h1
            className="font-potter text-2xl mobile:text-4xl smart:text-5xl md:text-6xl lg:text-8xl font-normal text-hover text-center"
            id="faculty">
            Choose your Hogwarts house
          </h1>
          <div className="flex flex-wrap justify-center gap-4 mobile:gap-10 mobile:px-6 smart:px-0 smart:gap-0 smart:flex-nowrap smart:justify-between">
            <Link className="block h-full duration-300 transform hover:scale-125" to="/catalog" state={'Hufflepuff'}>
              <div className="w-28 h-28 md:w-36 md:h-36 lg:w-48 lg:h-48 xl:w-64 xl:h-64 bg-huffle bg-contain bg-center bg-no-repeat hufflepuff"></div>
            </Link>
            <Link className="block h-full duration-300 transform hover:scale-125" to="/catalog" state={'Gryffindor'}>
              <div className="w-28 h-28 md:w-36 md:h-36 lg:w-48 lg:h-48 xl:w-64 xl:h-64 bg-leo bg-contain bg-center bg-no-repeat lion"></div>
            </Link>
            <Link className="block h-full duration-300 transform hover:scale-125" to="/catalog" state={'Slytherin'}>
              <div className="w-28 h-28 md:w-36 md:h-36 lg:w-48 lg:h-48 xl:w-64 xl:h-64 bg-snake bg-contain bg-center bg-no-repeat slytherin"></div>
            </Link>
            <Link className="block h-full duration-300 transform hover:scale-125" to="/catalog" state={'Ravenclaw'}>
              <div className="w-28 h-28 md:w-36 md:h-36 lg:w-48 lg:h-48 xl:w-64 xl:h-64 bg-raven bg-contain bg-center bg-no-repeat ravenclaw "></div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
